export { default } from "./RoleQuery";



// WEBPACK FOOTER //
// ./src/queries/RoleQuery/index.ts